module.exports = __webpack_public_path__ + "static/media/logo_archdiocese_white_150.2cae5cfa.png";